import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../lib/api";
import { EditableText } from "./live/Editable";

export default function FacultySection() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/faculty", { params: { active_only: true } }).then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section className="py-24 bg-slate-50 relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-yellow-100 rounded-full blur-3xl" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <EditableText path="home.faculty.kicker" as="p" className="kicker mb-3">
            Meet our faculty
          </EditableText>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0B2A6B] leading-tight">
            <EditableText path="home.faculty.heading" as="span">
              Curriculum designed by German experts & Indian specialists
            </EditableText>
          </h2>
          <EditableText path="home.faculty.subtitle" as="p" multiline className="text-slate-600 mt-4">
            Our faculty is highly trained and brings great depth of experience to every classroom.
          </EditableText>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5">
          {items.map((f, i) => (
            <div
              key={f.id}
              className="group relative overflow-hidden rounded-2xl bg-white shadow-sm hover:shadow-xl border border-slate-100 tilt-card animate-fade-up"
              style={{ animationDelay: `${i * 0.05}s` }}
            >
              <div className="aspect-square overflow-hidden bg-slate-100">
                <img
                  src={f.image_url || "https://images.unsplash.com/photo-1633332755192-727a05c4013d?w=400"}
                  alt={f.name}
                  className="w-full h-full object-cover zoom-img"
                />
              </div>
              <div className="p-4 text-center">
                <h3 className="font-bold text-[#0B2A6B] text-sm leading-tight">{f.name}</h3>
                <p className="text-xs text-slate-500 mt-1">{f.role}</p>
              </div>
              {/* Hover overlay with bio */}
              <div className="absolute inset-0 bg-[#0B2A6B]/95 text-white p-4 flex flex-col justify-end opacity-0 group-hover:opacity-100 transition">
                <h3 className="font-bold text-yellow-400 text-sm">{f.name}</h3>
                <p className="text-[11px] text-yellow-200 mb-2">{f.role}</p>
                <p className="text-xs leading-relaxed line-clamp-5">{f.bio}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/faculty"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-lg bg-[#0B2A6B] text-white font-semibold hover:bg-[#061a47] transition group"
          >
            Join our team
            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition" />
          </Link>
        </div>
      </div>
    </section>
  );
}
